/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Where the run creating an archive stands.
 */
export enum EnumArchiveRunState {
    /**
     * Queued, not picked up yet.
     */
    Scheduled = 0,
    /**
     * Writing the archive.
     */
    Running = 1,
    /**
     * The archive is written and can be downloaded until it expires.
     */
    Finished = 2,
    /**
     * No archive was written; the messages say why.
     */
    Failed = 3,
}
